import { useEffect } from 'react';
import { isLocalHost } from '../../shared/host_utils.js';

const LOCAL_DEV_ORIGINS = new Set(['http://localhost:3002', 'http://127.0.0.1:3002']);

function rewriteAnchorHref(anchor) {
    if (!(anchor instanceof HTMLAnchorElement)) return;

    const rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#')) return;

    let parsedHref;
    try {
        parsedHref = new URL(rawHref, window.location.origin);
    } catch (error) {
        return;
    }

    if (!parsedHref.pathname.includes('/next/')) return;

    const isSameOrigin = parsedHref.origin === window.location.origin;
    const isLocalDevOrigin = LOCAL_DEV_ORIGINS.has(parsedHref.origin) ||
        (isLocalHost(parsedHref.hostname) && parsedHref.port === '3002');
    if (!isSameOrigin && !isLocalDevOrigin) return;

    parsedHref.protocol = 'http:';
    parsedHref.hostname = window.location.hostname;
    parsedHref.port = '3003';
    anchor.setAttribute('href', parsedHref.toString());
}

function rewriteAllAnchors() {
    document.querySelectorAll('a[href]').forEach((anchor) => rewriteAnchorHref(anchor));
}

export default function LocalhostNextAnchorRewrite() {
    useEffect(() => {
        if (!isLocalHost(window.location.hostname)) return;

        rewriteAllAnchors();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.target instanceof HTMLAnchorElement) {
                    rewriteAnchorHref(mutation.target);
                    return;
                }

                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof Element)) return;
                    if (node.matches('a[href]')) rewriteAnchorHref(node);
                    node.querySelectorAll('a[href]').forEach((anchor) => rewriteAnchorHref(anchor));
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['href'],
        });

        return () => observer.disconnect();
    }, []);

    return null;
}
